import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import client, { apiErr } from "../lib/api";
import { Button, Card } from "../components/ui";
import { ShieldQuestion, CheckCircle2, XCircle } from "lucide-react";

export default function ChangeReview() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [detail, setDetail] = useState(null);
  const [result, setResult] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setErr("Missing review token."); return; }
    client.get(`/auth/contact-change?token=${encodeURIComponent(token)}`)
      .then((r) => setDetail(r.data)).catch((e) => setErr(apiErr(e)));
  }, [token]);

  const resolve = async (action) => {
    setBusy(true); setErr("");
    try {
      const { data } = await client.post("/auth/contact-change/resolve", { token, action });
      setResult(data.status);
    } catch (e) { setErr(apiErr(e)); }
    setBusy(false);
  };

  return (
    <div className="grid min-h-screen place-items-center p-6" style={{ background: "var(--app-bg)" }}>
      <Card className="w-full max-w-md space-y-4" data-testid="change-review">
        <div className="flex items-center gap-2 font-head text-xl"><ShieldQuestion size={22} className="text-[var(--primary)]" /> Confirm account change</div>
        {err && <div className="text-sm text-[#DA1E28]" data-testid="cr-error">{err}</div>}
        {result === "confirmed" && <div className="flex items-center gap-2 text-[#24A148]" data-testid="cr-confirmed"><CheckCircle2 size={18} /> Change confirmed and applied.</div>}
        {result === "declined" && <div className="flex items-center gap-2 text-[#DA1E28]" data-testid="cr-declined"><XCircle size={18} /> Change declined. The account has been blocked for protection — contact the vendor or customer support to restore access.</div>}
        {!result && detail && !detail.expired && detail.status === "pending" && (
          <>
            <p className="text-sm opacity-70">A request was made to change the account contact details:</p>
            <div className="rounded-md border border-black/10 dark:border-white/10 p-3 text-sm" data-testid="cr-detail">
              <div className="opacity-60">Current login email: {detail.current_email}</div>
              {detail.new_email && <div>New email: <b>{detail.new_email}</b></div>}
              {detail.new_phone && <div>New phone: <b>{detail.new_phone}</b></div>}
            </div>
            <p className="text-xs opacity-60">If you requested this, confirm it. If you did not, decline it — access will be blocked until the vendor restores it.</p>
            <div className="flex justify-between gap-2">
              <Button variant="danger" onClick={() => resolve("decline")} disabled={busy} data-testid="cr-decline"><XCircle size={15} /> I did not request this</Button>
              <Button onClick={() => resolve("confirm")} disabled={busy} data-testid="cr-confirm"><CheckCircle2 size={15} /> Confirm change</Button>
            </div>
          </>
        )}
        {!result && detail && (detail.expired || detail.status !== "pending") && (
          <p className="text-sm opacity-70" data-testid="cr-unavailable">This request is no longer available ({detail.expired ? "expired" : detail.status}).</p>
        )}
      </Card>
    </div>
  );
}
